// THE PARADE clock, shared so the server, the offline driver and the client's menu ("PARADE IN 12:34") agree.
// Every hour on the hour, UTC minutes [PARADE_MIN_START, PARADE_MIN_END): a round that STARTS inside the window is a
// Parade round (it runs to its end even if the window closes mid-round).
import { PARADE_MIN_START, PARADE_MIN_END } from "./tuning";

const HOUR = 3600_000, MIN = 60_000;

/** is a round starting at this UTC instant a Parade round? */
export function isParade(utcMs: number): boolean {
  const m = Math.floor((utcMs % HOUR) / MIN);
  return m >= PARADE_MIN_START && m < PARADE_MIN_END;
}

/** the next window: when it opens and closes (UTC ms). Inside a window, `open` is the current window's start. */
export function nextParade(utcMs: number): { open: number; close: number; live: boolean; inMs: number } {
  const hourStart = utcMs - (utcMs % HOUR);
  let open = hourStart + PARADE_MIN_START * MIN, close = hourStart + PARADE_MIN_END * MIN;
  if (utcMs >= close) { open += HOUR; close += HOUR; }
  const live = utcMs >= open && utcMs < close;
  return { open, close, live, inMs: live ? 0 : open - utcMs };
}
